module.exports = __webpack_public_path__ + "ts-code-blocks.3W-L-vh3.svg";